import { createSlice } from '@reduxjs/toolkit';

import { TEAM_USER_STATE_INACTIVE } from '../../components/SocialButtons/Share/InternalShare/constants/share';

import { getFormattedUser } from '../../helpers/user';

const initialState = {
  isLoading: false,
  totalCount: 0,
  page: 1,
  userList: [],
  // autocomplete
  autocompleteUserList: [],
  autocompleteSelectedUserList: [],
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'teamShare',
  initialState,
  reducers: {
    getSharedTeamListAction: (state) => {
      state.isLoading = true;
    },
    setSharedTeamListAction: (state, action) => {
      state.totalCount = action.payload.totalCount;
      state.page = action.payload.page;
      state.userList = action.payload.userList;
      state.isLoading = false;
    },
    getAutocompleteUserListAction: (state) => {
      state.isLoading = true;
    },
    setAutocompleteUserListAction: (state, action) => {
      state.autocompleteUserList = action.payload.map(getFormattedUser);
      state.isLoading = false;
    },
    setAutocompleteSelectedUserListAction: (state, action) => {
      state.autocompleteSelectedUserList = action.payload;
    },
    sendShareAction: (state) => state,
    revokeShareAction: (state, action) => {
      const user = state.userList.find(({ id }) => id === action.payload.userId);
      user.status = TEAM_USER_STATE_INACTIVE;
    },
    clearAllAction: () => initialState,
  },
});

export const {
  getSharedTeamListAction,
  setSharedTeamListAction,
  getAutocompleteUserListAction,
  setAutocompleteUserListAction,
  setAutocompleteSelectedUserListAction,
  sendShareAction,
  revokeShareAction,
  clearAllAction,
} = slice.actions;
